<template>
  <div v-if="showFractionFilter" :class="['product-filter', { 'product-filter--has-selected': hasSelectedFractions }]">
    <div v-if="header || text" class="product-filter__top">
      <div v-if="header" class="product-filter__header">
        {{ header }}
      </div>

      <div v-if="text" class="product-filter__text">
        {{ text }}
      </div>
    </div>

    <oie-layout-grid css-classes="grid--four product-filter__grid">
      <div v-for="(item, row) in fractions" :key="`fraction-${row}`" class="filter-block">
        <div class="filter-block__header">
          {{ item.fractionId }}
        </div>
        <div class="filter-block__container">
          <oie-base-checkbox
            v-for="itemData in item.fractionTypes"
            v-show="show(itemData)"
            :key="`fractionData-${itemData.name}`"
            v-model="selectedFractionTypes"
            text-color="blue"
            size="large"
            :val="itemData"
            :is-for="itemData.name"
            :text="itemData.name">
          </oie-base-checkbox>
        </div>
      </div>
    </oie-layout-grid>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    header: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    isToggle: {
      type: Boolean,
      default: false
    },
    showFractionFilter: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isOpen: false
  }),
  computed: {
    fractions() {
      return this.$store.getters['fractions/allFractions']
    },
    selectedFractionTypes: {
      get: function () {
        return this.$store.getters['fractions/selectedFractionTypes']
      },
      set: function (fractionTypes) {
        this.$store.dispatch('fractions/updateSelectedFractionTypes', fractionTypes)
      }
    },
    hasSelectedFractions() {
      return this.$store.getters['fractions/selectedFractionTypes'].length > 0
    }
  },
  mounted() {
    this.$store.dispatch('fractions/setFractions', this.clientModel.vehicleFilterFractions || [])
    this.$store.dispatch('fractions/setFromQueryParams').then(queryParamFractionTypes => {
      _.forEach(queryParamFractionTypes, selectedFractionType => {
        this.selectedFractionTypes.push(selectedFractionType)
      })
    })
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen
    },
    show(fractionType) {
      const selectedFractionTypes = this.$store.getters['fractions/selectedFractionTypes']
      if(selectedFractionTypes.length === 0) {
        return true
      }
      const allFractionTypesExceptSelected = _.chain(this.fractions).flatMap('fractionTypes').difference().value()
      const result = []
      _.forEach(selectedFractionTypes, selectedFractionType => {
        _.forEach(allFractionTypesExceptSelected, ft => {
          const matchItems = _.intersection(ft.items, selectedFractionType.items).length > 0
          const matchedFractions = _.intersection(ft.fractionGroupId, selectedFractionType.fractionGroupId).length > 0
          if(matchItems && matchedFractions) {
            result.push(ft)
          }
        })
      })
      return _.includes(result, fractionType) && this.singlingToggle(fractionType)
    },
    singlingToggle(fractionType) {
      const selectedFractionTypes = this.$store.getters['fractions/selectedFractionTypes']
      const parent = _.find(this.fractions, fraction => _.includes(fraction.fractionTypes, fractionType))
      const groupSize = _.intersection(parent.fractionTypes, selectedFractionTypes).length
      return groupSize === 0 || (groupSize === 1 && _.includes(selectedFractionTypes, fractionType))
    }
  }
}
</script>

<style lang="scss" scoped>
.product-filter {
  @include caption;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 2.5rem;
  padding: measure(half);
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
}

.product-filter--has-selected {
  background-color: color(background-green-4);
  border-color: color(border-green-3);
}

.product-filter__top {
  margin-bottom: measure(half);
}

.product-filter__header {
  @include body-smaller-bold;

  @include media(small) {
    @include h3-bold;
  }
}

.product-filter__text {
  @include body-smaller;

  @include media(small) {
    @include h3;
  }
}

.product-filter__grid {
  width: 100%;
}

.filter-block {
  padding: measure(half);
  background-color: color(background-white);
}

.filter-block__header {
  @include h3-bold;
  margin-bottom: measure(half);
}

.filter-block__container > *:not(:last-child) {
  margin-bottom: measure(quarter);
}
</style>
